import {state} from "../../state";
import {useSnapshot} from "valtio";
import React, {Suspense} from "react";
import {Bounds} from '@react-three/drei';
import {MemDynamicModelLoader} from "./DynamicModelLoader";

const MultiModelLoader = () => {
  
  const {getCurrModels, folderLocation, fileFormat} = useSnapshot(state);
  
  return (
    <>
      <Bounds clip observe damping={0} margin={1.2}>
        {getCurrModels.map((model, index) => {
          return (
            <Suspense key={index} fallback={null}>
              <MemDynamicModelLoader key={index} modelRef={model} fileFormat={fileFormat} location={folderLocation}/>
            </Suspense>
          )
        })}
      </Bounds>
    </>
  );
}

export default MultiModelLoader;
